import { render, staticRenderFns } from "./multiselectInput.vue?vue&type=template&id=0bc658be&scoped=true&"
import script from "./multiselectInput.vue?vue&type=script&lang=js&"
export * from "./multiselectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc658be",
  null
  
)

export default component.exports